export const dateNowUTC = () => new Date().toISOString();
